"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirportTransferDirection = void 0;
var AirportTransferDirection;
(function (AirportTransferDirection) {
    // None, when it isn't an airport transfer
    AirportTransferDirection[AirportTransferDirection["None"] = 0] = "None";
    // FromAirport, when the order origin is the airport
    AirportTransferDirection[AirportTransferDirection["FromAirport"] = 1] = "FromAirport";
    // ToAirport, when the order destination is the airport
    AirportTransferDirection[AirportTransferDirection["ToAirport"] = 2] = "ToAirport";
})(AirportTransferDirection || (exports.AirportTransferDirection = AirportTransferDirection = {}));
//# sourceMappingURL=airport-transfer-direction.enum.js.map